"use strict";
exports.__esModule = true;
var common_1 = require("../models/common");
var reserved_words_1 = require("./reserved-words");
var validateActivationPhrase = function (value, isAdmin, field) {
    if (field === void 0) { field = 'Имя'; }
    value = value.toLowerCase();
    if (value === '') {
        return '';
    }
    var error = reserved_words_1["default"](value, isAdmin, field);
    if (error) {
        return error;
    }
    if (/[.,:;!?%^&*()_@]/.test(value)) {
        return field + " \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u043D\u0435\u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0435 \u0441\u0438\u043C\u0432\u043E\u043B\u044B";
    }
    if (!/[a-zA-Zа-яА-ЯёЁ]/.test(value)) {
        return field + " \u0443\u043A\u0430\u0437\u0430\u043D\u043E \u043D\u0435\u0432\u0435\u0440\u043D\u043E";
    }
    if (common_1.isQuoted(value)) {
        return field + " \u043D\u0435 \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u0432 \u043A\u0430\u0432\u044B\u0447\u043A\u0430\u0445";
    }
    return '';
};
exports["default"] = validateActivationPhrase;
